import { Evidence } from '@/@types/Evidence';
import { EvidenceCard } from '@/components/table/EvidenceCard';
import { InlineChipWidget } from '@/components/widgets/InlineChipWidget';
import { PaperDetails } from '@/models/Report';

interface InlinePaperEvidenceProps {
  evidence: Evidence[];
  label: string;
  paper?: PaperDetails;
  corpusId?: number;
}

export const InlinePaperEvidence = ({
  corpusId,
  evidence,
  paper,
  label,
}: InlinePaperEvidenceProps) => {
  const paperUrl = `https://www.semanticscholar.org/p/${corpusId}`;

  if (!evidence.length) {
    return (
      <a href={paperUrl} target="_blank" rel="noopener noreferrer">
        <InlineChipWidget label={label} />
      </a>
    );
  }
  return (
    <EvidenceCard
      corpusId={corpusId}
      paper={paper}
      evidences={evidence}
      anchor={
        <a href={paperUrl} target="_blank" rel="noopener noreferrer">
          <InlineChipWidget label={label} />
        </a>
      }
    />
  );
};
